// Shared cleanup for client-side authoring "auto-recovery" drafts.
//
// The mentor authoring wizards (blueprint, career-post, path-builder, module,
// question) autosave in-progress form state to localStorage under keys prefixed
// with `udb-draft-` so an accidental refresh/crash doesn't lose work. These keys
// are intentionally NOT persisted server-side — that's the explicit "Save Draft"
// button's job.
//
// Because the caches live in localStorage (shared across users on one browser) and
// are keyed globally, they must be wiped whenever the active user changes, or one
// mentor's in-progress form leaks into the next mentor's "New …" wizard. Call
// clearAllDrafts() on logout (covers explicit sign-out AND session-expiry, which
// routes through the auth store's logout()) and on successful login (covers the
// "previous user never logged out, someone else signs in" case).
export const DRAFT_KEY_PREFIX = 'udb-draft-';

export function clearAllDrafts(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(DRAFT_KEY_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => localStorage.removeItem(k));
  } catch {
    // localStorage unavailable (private mode / disabled) — nothing to clear.
  }
}
